module.exports = __webpack_public_path__ + "img/ic_burger_teams.37d67acd.svg";